module.exports = __webpack_public_path__ + "img/kehu_7@2x.0599f834.png";